// @generated by protoc-gen-es-ns v0.0.0 with parameter "target=ts"
// @generated from file kikoff_canada/protobuf/services/subscription_service.proto (package kikoff_canada.protobuf.services, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { Error } from "../types/error_pb.js";
import { SubscriptionPlan } from "../models/subscription_plan_pb.js";
import { UserSubscription } from "../models/user_subscription_pb.js";
import { CreditLine } from "../models/lending/credit_line_pb.js";

/**
 * @generated from message kikoff_canada.protobuf.services.ListSubscriptionPlansResponse
 */
export class ListSubscriptionPlansResponse extends Message<ListSubscriptionPlansResponse> {
  /**
   * @generated from field: repeated kikoff_canada.protobuf.types.Error errors = 1;
   */
  errors: Error[] = [];

  /**
   * @generated from field: repeated kikoff_canada.protobuf.models.SubscriptionPlan plans = 2;
   */
  plans: SubscriptionPlan[] = [];

  constructor(data?: PartialMessage<ListSubscriptionPlansResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "kikoff_canada.protobuf.services.ListSubscriptionPlansResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "errors", kind: "message", T: Error, repeated: true },
    { no: 2, name: "plans", kind: "message", T: SubscriptionPlan, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListSubscriptionPlansResponse {
    return new ListSubscriptionPlansResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListSubscriptionPlansResponse {
    return new ListSubscriptionPlansResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListSubscriptionPlansResponse {
    return new ListSubscriptionPlansResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListSubscriptionPlansResponse | PlainMessage<ListSubscriptionPlansResponse> | undefined, b: ListSubscriptionPlansResponse | PlainMessage<ListSubscriptionPlansResponse> | undefined): boolean {
    return proto3.util.equals(ListSubscriptionPlansResponse, a, b);
  }

  static _enums: {
  };
}

/**
 * @generated from message kikoff_canada.protobuf.services.OpenSubscriptionRequest
 */
export class OpenSubscriptionRequest extends Message<OpenSubscriptionRequest> {
  /**
   * @generated from field: string plan_id = 1;
   */
  planId = "";

  constructor(data?: PartialMessage<OpenSubscriptionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "kikoff_canada.protobuf.services.OpenSubscriptionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "plan_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): OpenSubscriptionRequest {
    return new OpenSubscriptionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): OpenSubscriptionRequest {
    return new OpenSubscriptionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): OpenSubscriptionRequest {
    return new OpenSubscriptionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: OpenSubscriptionRequest | PlainMessage<OpenSubscriptionRequest> | undefined, b: OpenSubscriptionRequest | PlainMessage<OpenSubscriptionRequest> | undefined): boolean {
    return proto3.util.equals(OpenSubscriptionRequest, a, b);
  }

  static _enums: {
  };
}

/**
 * @generated from message kikoff_canada.protobuf.services.OpenSubscriptionResponse
 */
export class OpenSubscriptionResponse extends Message<OpenSubscriptionResponse> {
  /**
   * @generated from field: repeated kikoff_canada.protobuf.types.Error errors = 1;
   */
  errors: Error[] = [];

  /**
   * @generated from field: kikoff_canada.protobuf.models.UserSubscription user_subscription = 2;
   */
  userSubscription?: UserSubscription;

  constructor(data?: PartialMessage<OpenSubscriptionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "kikoff_canada.protobuf.services.OpenSubscriptionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "errors", kind: "message", T: Error, repeated: true },
    { no: 2, name: "user_subscription", kind: "message", T: UserSubscription },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): OpenSubscriptionResponse {
    return new OpenSubscriptionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): OpenSubscriptionResponse {
    return new OpenSubscriptionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): OpenSubscriptionResponse {
    return new OpenSubscriptionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: OpenSubscriptionResponse | PlainMessage<OpenSubscriptionResponse> | undefined, b: OpenSubscriptionResponse | PlainMessage<OpenSubscriptionResponse> | undefined): boolean {
    return proto3.util.equals(OpenSubscriptionResponse, a, b);
  }

  static _enums: {
  };
}

/**
 * @generated from message kikoff_canada.protobuf.services.ListUserSubscriptionsResponse
 */
export class ListUserSubscriptionsResponse extends Message<ListUserSubscriptionsResponse> {
  /**
   * @generated from field: repeated kikoff_canada.protobuf.types.Error errors = 1;
   */
  errors: Error[] = [];

  /**
   * @generated from field: repeated kikoff_canada.protobuf.models.UserSubscription user_subscriptions = 2;
   */
  userSubscriptions: UserSubscription[] = [];

  constructor(data?: PartialMessage<ListUserSubscriptionsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "kikoff_canada.protobuf.services.ListUserSubscriptionsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "errors", kind: "message", T: Error, repeated: true },
    { no: 2, name: "user_subscriptions", kind: "message", T: UserSubscription, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListUserSubscriptionsResponse {
    return new ListUserSubscriptionsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListUserSubscriptionsResponse {
    return new ListUserSubscriptionsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListUserSubscriptionsResponse {
    return new ListUserSubscriptionsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListUserSubscriptionsResponse | PlainMessage<ListUserSubscriptionsResponse> | undefined, b: ListUserSubscriptionsResponse | PlainMessage<ListUserSubscriptionsResponse> | undefined): boolean {
    return proto3.util.equals(ListUserSubscriptionsResponse, a, b);
  }

  static _enums: {
  };
}

/**
 * @generated from message kikoff_canada.protobuf.services.ChangeSubscriptionPlanRequest
 */
export class ChangeSubscriptionPlanRequest extends Message<ChangeSubscriptionPlanRequest> {
  /**
   * @generated from field: string plan_id = 1;
   */
  planId = "";

  constructor(data?: PartialMessage<ChangeSubscriptionPlanRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "kikoff_canada.protobuf.services.ChangeSubscriptionPlanRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "plan_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ChangeSubscriptionPlanRequest {
    return new ChangeSubscriptionPlanRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ChangeSubscriptionPlanRequest {
    return new ChangeSubscriptionPlanRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ChangeSubscriptionPlanRequest {
    return new ChangeSubscriptionPlanRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ChangeSubscriptionPlanRequest | PlainMessage<ChangeSubscriptionPlanRequest> | undefined, b: ChangeSubscriptionPlanRequest | PlainMessage<ChangeSubscriptionPlanRequest> | undefined): boolean {
    return proto3.util.equals(ChangeSubscriptionPlanRequest, a, b);
  }

  static _enums: {
  };
}

/**
 * @generated from message kikoff_canada.protobuf.services.ChangeSubscriptionPlanResponse
 */
export class ChangeSubscriptionPlanResponse extends Message<ChangeSubscriptionPlanResponse> {
  /**
   * @generated from field: repeated kikoff_canada.protobuf.types.Error errors = 1;
   */
  errors: Error[] = [];

  /**
   * @generated from field: kikoff_canada.protobuf.models.UserSubscription user_subscription = 2;
   */
  userSubscription?: UserSubscription;

  /**
   * @generated from field: kikoff_canada.protobuf.models.lending.CreditLine credit_line = 3;
   */
  creditLine?: CreditLine;

  constructor(data?: PartialMessage<ChangeSubscriptionPlanResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "kikoff_canada.protobuf.services.ChangeSubscriptionPlanResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "errors", kind: "message", T: Error, repeated: true },
    { no: 2, name: "user_subscription", kind: "message", T: UserSubscription },
    { no: 3, name: "credit_line", kind: "message", T: CreditLine },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ChangeSubscriptionPlanResponse {
    return new ChangeSubscriptionPlanResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ChangeSubscriptionPlanResponse {
    return new ChangeSubscriptionPlanResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ChangeSubscriptionPlanResponse {
    return new ChangeSubscriptionPlanResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ChangeSubscriptionPlanResponse | PlainMessage<ChangeSubscriptionPlanResponse> | undefined, b: ChangeSubscriptionPlanResponse | PlainMessage<ChangeSubscriptionPlanResponse> | undefined): boolean {
    return proto3.util.equals(ChangeSubscriptionPlanResponse, a, b);
  }

  static _enums: {
  };
}

/**
 * DEPRECATED
 *    Use a better named RPC: ChangeSubscriptionPlanRequest, as it won't change when
 *
 * @generated from message kikoff_canada.protobuf.services.ChangeSubscriptionPlanAndCreditLineAgreementRequest
 */
export class ChangeSubscriptionPlanAndCreditLineAgreementRequest extends Message<ChangeSubscriptionPlanAndCreditLineAgreementRequest> {
  /**
   * @generated from field: string plan_id = 1;
   */
  planId = "";

  constructor(data?: PartialMessage<ChangeSubscriptionPlanAndCreditLineAgreementRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "kikoff_canada.protobuf.services.ChangeSubscriptionPlanAndCreditLineAgreementRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "plan_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ChangeSubscriptionPlanAndCreditLineAgreementRequest {
    return new ChangeSubscriptionPlanAndCreditLineAgreementRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ChangeSubscriptionPlanAndCreditLineAgreementRequest {
    return new ChangeSubscriptionPlanAndCreditLineAgreementRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ChangeSubscriptionPlanAndCreditLineAgreementRequest {
    return new ChangeSubscriptionPlanAndCreditLineAgreementRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ChangeSubscriptionPlanAndCreditLineAgreementRequest | PlainMessage<ChangeSubscriptionPlanAndCreditLineAgreementRequest> | undefined, b: ChangeSubscriptionPlanAndCreditLineAgreementRequest | PlainMessage<ChangeSubscriptionPlanAndCreditLineAgreementRequest> | undefined): boolean {
    return proto3.util.equals(ChangeSubscriptionPlanAndCreditLineAgreementRequest, a, b);
  }

  static _enums: {
  };
}

/**
 * DEPRECATED
 *    Use a better named RPC: ChangeSubscriptionPlanResponse, as it won't change when
 *
 * @generated from message kikoff_canada.protobuf.services.ChangeSubscriptionPlanAndCreditLineAgreementResponse
 */
export class ChangeSubscriptionPlanAndCreditLineAgreementResponse extends Message<ChangeSubscriptionPlanAndCreditLineAgreementResponse> {
  /**
   * @generated from field: repeated kikoff_canada.protobuf.types.Error errors = 1;
   */
  errors: Error[] = [];

  /**
   * @generated from field: kikoff_canada.protobuf.models.UserSubscription user_subscription = 2;
   */
  userSubscription?: UserSubscription;

  /**
   * @generated from field: kikoff_canada.protobuf.models.lending.CreditLine credit_line = 3;
   */
  creditLine?: CreditLine;

  constructor(data?: PartialMessage<ChangeSubscriptionPlanAndCreditLineAgreementResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "kikoff_canada.protobuf.services.ChangeSubscriptionPlanAndCreditLineAgreementResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "errors", kind: "message", T: Error, repeated: true },
    { no: 2, name: "user_subscription", kind: "message", T: UserSubscription },
    { no: 3, name: "credit_line", kind: "message", T: CreditLine },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ChangeSubscriptionPlanAndCreditLineAgreementResponse {
    return new ChangeSubscriptionPlanAndCreditLineAgreementResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ChangeSubscriptionPlanAndCreditLineAgreementResponse {
    return new ChangeSubscriptionPlanAndCreditLineAgreementResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ChangeSubscriptionPlanAndCreditLineAgreementResponse {
    return new ChangeSubscriptionPlanAndCreditLineAgreementResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ChangeSubscriptionPlanAndCreditLineAgreementResponse | PlainMessage<ChangeSubscriptionPlanAndCreditLineAgreementResponse> | undefined, b: ChangeSubscriptionPlanAndCreditLineAgreementResponse | PlainMessage<ChangeSubscriptionPlanAndCreditLineAgreementResponse> | undefined): boolean {
    return proto3.util.equals(ChangeSubscriptionPlanAndCreditLineAgreementResponse, a, b);
  }

  static _enums: {
  };
}

/**
 * @generated from message kikoff_canada.protobuf.services.ChangeUserSubscriptionAutorenewalRequest
 */
export class ChangeUserSubscriptionAutorenewalRequest extends Message<ChangeUserSubscriptionAutorenewalRequest> {
  /**
   * @generated from field: string user_subscription_id = 1;
   */
  userSubscriptionId = "";

  /**
   * @generated from field: kikoff_canada.protobuf.services.ChangeUserSubscriptionAutorenewalRequest.AutorenewState state = 2;
   */
  state = ChangeUserSubscriptionAutorenewalRequest.AutorenewState.UNKNOWN;

  constructor(data?: PartialMessage<ChangeUserSubscriptionAutorenewalRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "kikoff_canada.protobuf.services.ChangeUserSubscriptionAutorenewalRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_subscription_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "state", kind: "enum", T: proto3.getEnumType(ChangeUserSubscriptionAutorenewalRequest.AutorenewState) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ChangeUserSubscriptionAutorenewalRequest {
    return new ChangeUserSubscriptionAutorenewalRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ChangeUserSubscriptionAutorenewalRequest {
    return new ChangeUserSubscriptionAutorenewalRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ChangeUserSubscriptionAutorenewalRequest {
    return new ChangeUserSubscriptionAutorenewalRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ChangeUserSubscriptionAutorenewalRequest | PlainMessage<ChangeUserSubscriptionAutorenewalRequest> | undefined, b: ChangeUserSubscriptionAutorenewalRequest | PlainMessage<ChangeUserSubscriptionAutorenewalRequest> | undefined): boolean {
    return proto3.util.equals(ChangeUserSubscriptionAutorenewalRequest, a, b);
  }

  static _enums: {
    AutorenewState: typeof ChangeUserSubscriptionAutorenewalRequest.AutorenewState,
  };
}

export namespace ChangeUserSubscriptionAutorenewalRequest {
  /**
   * @generated from enum kikoff_canada.protobuf.services.ChangeUserSubscriptionAutorenewalRequest.AutorenewState
   */
  export enum AutorenewState {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: ENABLED = 1;
     */
    ENABLED = 1,

    /**
     * @generated from enum value: DISABLED = 2;
     */
    DISABLED = 2,
  }
  // Retrieve enum metadata with: proto3.getEnumType(ChangeUserSubscriptionAutorenewalRequest.AutorenewState)
  proto3.util.setEnumType(ChangeUserSubscriptionAutorenewalRequest.AutorenewState, "kikoff_canada.protobuf.services.ChangeUserSubscriptionAutorenewalRequest.AutorenewState", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "ENABLED" },
    { no: 2, name: "DISABLED" },
  ]);
}

/**
 * @generated from message kikoff_canada.protobuf.services.ChangeUserSubscriptionAutorenewalResponse
 */
export class ChangeUserSubscriptionAutorenewalResponse extends Message<ChangeUserSubscriptionAutorenewalResponse> {
  /**
   * @generated from field: repeated kikoff_canada.protobuf.types.Error errors = 1;
   */
  errors: Error[] = [];

  /**
   * @generated from field: kikoff_canada.protobuf.models.UserSubscription user_subscription = 2;
   */
  userSubscription?: UserSubscription;

  constructor(data?: PartialMessage<ChangeUserSubscriptionAutorenewalResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "kikoff_canada.protobuf.services.ChangeUserSubscriptionAutorenewalResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "errors", kind: "message", T: Error, repeated: true },
    { no: 2, name: "user_subscription", kind: "message", T: UserSubscription },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ChangeUserSubscriptionAutorenewalResponse {
    return new ChangeUserSubscriptionAutorenewalResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ChangeUserSubscriptionAutorenewalResponse {
    return new ChangeUserSubscriptionAutorenewalResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ChangeUserSubscriptionAutorenewalResponse {
    return new ChangeUserSubscriptionAutorenewalResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ChangeUserSubscriptionAutorenewalResponse | PlainMessage<ChangeUserSubscriptionAutorenewalResponse> | undefined, b: ChangeUserSubscriptionAutorenewalResponse | PlainMessage<ChangeUserSubscriptionAutorenewalResponse> | undefined): boolean {
    return proto3.util.equals(ChangeUserSubscriptionAutorenewalResponse, a, b);
  }

  static _enums: {
  };
}

